// Два документа, на которых стоит вход в программу: политика конфиденциальности и условия
// использования.
//
// Адреса в одном месте, потому что ссылаются на них два экрана — вход и «Мой вход», — и
// разъехаться они не имеют права: магазин сверяет ссылку на политику внутри приложения с той,
// что указана в карточке. Своим экраном тексты не показываем: вторая копия разойдётся с сайтом
// в первый же день.

export const АДРЕС_ПОЛИТИКИ = 'https://bark.uxcode.agency/app-privacy.html';
export const АДРЕС_УСЛОВИЙ = 'https://bark.uxcode.agency/terms.html';
